import React from 'react';
import SuggestedSuburbs from '@domain-group/fe-co-typeahead/lib/js/components/suggested-suburbs';
import { Option } from '../types';

type SuggestedSuburbsProps = React.ComponentProps<typeof SuggestedSuburbs>;

interface SuggestedSuburbsWrapperProps {
  handleSelect: SuggestedSuburbsProps['onSelect'];
  input?: string;
  selectedItems: Option[];
}

const SuggestedSuburbsWrapper = ({
  handleSelect,
  input,
  selectedItems,
}: SuggestedSuburbsWrapperProps): JSX.Element => (
  <SuggestedSuburbs
    onSelect={handleSelect}
    input={input}
    selectedItems={selectedItems}
    searchMode="Sale"
    useDesignTokens
    showResultsLogo
    maxResults={5}
  />
);

export default SuggestedSuburbsWrapper;
